export default {
  components: {},
  props: {
    screen: {
      type: Object,
      default: () => {
      }
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  methods: {},
  created() {
  },
  mounted() {
  },
  computed: {},
  watch: {}
}



// WEBPACK FOOTER //
// ./src/views/Layout/Layout.js